import React from 'react'
import { SelectableRadio } from './SelectableRadio'
import { theme } from '../../Common/Credentials'

const RoundedTabButton = ({label,checked,onClick,size="md",className="",textSize}) => {
  return (
    
<div
      className={`tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-px-4 tw-py-1.5 tw-rounded-full tw-border 
        ${checked?theme === "classic" ? "tw-bg-[#f8f2ec] tw-border tw-border-[#4d4d4d]" : "tw-border-[#3574de] tw-bg-[#e4f0f7]": "tw-border-[#e2e8f0] tw-bg-transparent"} ${className}`}
      onClick={onClick}
    >
      <SelectableRadio checked={checked} size={size} />
      <span className={`UI-label ${textSize}`}>{label}</span>
      </div>
  )
}

export default RoundedTabButton